import { combineReducers } from 'redux';
import bundlesReducer from './bundlesSlice';
import productsReducer from './productsSlice';

export default combineReducers({
  bundles: bundlesReducer,
  products: productsReducer,
})
